import { render, staticRenderFns } from "./ResetLoginPwd.vue?vue&type=template&id=51a7fd22&scoped=true&"
import script from "./ResetLoginPwd.vue?vue&type=script&lang=js&"
export * from "./ResetLoginPwd.vue?vue&type=script&lang=js&"
import style0 from "./ResetLoginPwd.vue?vue&type=style&index=0&id=51a7fd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a7fd22",
  null
  
)

export default component.exports